import { ButtonProps } from "@mui/material"

export const BUTTON_WIDTH = 140

export const BUTTON_COMMON_PROPS: ButtonProps = {
    variant: "outlined",
    color: "info",
    sx: { width: BUTTON_WIDTH },
}
